// extracted by mini-css-extract-plugin
export default {"bar":"ald_top-bar__bar__BxOAr","leftSide":"ald_top-bar__leftSide__yO175","titleText":"ald_top-bar__titleText__SOn9d"};